import { Link } from "react-router-dom";
import { getRecentPosts } from "../data/blog";

export default function RecentPosts() {
  const posts = getRecentPosts(3);

  if (posts.length === 0) return null;

  return (
    <section className="mt-10">
      <h2 className="text-2xl font-bold mb-6">Recent Blog Posts</h2>
      <div className="grid gap-6 md:grid-cols-3">
        {posts.map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="block rounded-xl border border-slate-200 bg-white p-5 hover:shadow-lg transition-shadow group"
          >
            <div className="flex items-start justify-between mb-2">
              <h3 className="text-lg font-semibold text-slate-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                {post.title}
              </h3>
            </div>
            <p className="text-sm text-slate-600 mb-3 line-clamp-2">
              {post.description}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-slate-500">
                {new Date(post.date).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </span>
              <span className="text-sm font-medium text-primary-600 group-hover:underline">
                Read →
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
